import { Handle, Position } from 'reactflow';

export default function NodeHandles({ nodeType, isStart, data }) {
    const randomizerOutputs = data?.randomizerOutputs || [];
    const buttonItems = data?.buttonItems || [];

    if ((nodeType === 'payment' || nodeType === 'card_payment' || nodeType === 'spei_payment') && !isStart) return (
        <>
            <Handle type="source" id="source-unpaid" position={Position.Bottom} style={{ left: '28%' }}
                className="!w-3 !h-3 !bg-red-400 !border-2 !border-red-600" />
            <Handle type="source" id="source-paid" position={Position.Bottom} style={{ left: '72%' }}
                className="!w-3 !h-3 !bg-emerald-400 !border-2 !border-emerald-600" />
        </>
    );

    if ((nodeType === 'input' || nodeType === 'trigger') && !isStart) return (
        <>
            <Handle type="source" id="source-timeout" position={Position.Bottom} style={{ left: '28%' }}
                className="!w-3 !h-3 !bg-red-400 !border-2 !border-red-600" />
            <Handle type="source" id="source-ok" position={Position.Bottom} style={{ left: '72%' }}
                className="!w-3 !h-3 !bg-emerald-400 !border-2 !border-emerald-600" />
        </>
    );

    if (nodeType === 'randomizer' && !isStart) return (
        <>
            {randomizerOutputs.map((output, index) => {
                const pct = ((index + 1) / (randomizerOutputs.length + 1)) * 100;
                return (
                    <span key={`lbl-${output.id}`}
                        style={{ position: 'absolute', bottom: 6, left: `${pct}%`, transform: 'translateX(-50%)' }}
                        className="text-[8px] font-bold text-sky-300 pointer-events-none select-none">
                        {output.percent}%
                    </span>
                );
            })}
            {randomizerOutputs.map((output, index) => {
                const pct = ((index + 1) / (randomizerOutputs.length + 1)) * 100;
                return (
                    <Handle key={output.id} type="source" id={`source-${output.id}`}
                        position={Position.Bottom} style={{ left: `${pct}%` }}
                        className="!w-3 !h-3 !bg-sky-400 !border-2 !border-sky-600" />
                );
            })}
        </>
    );

    if (nodeType === 'buttons' && !isStart) return (
        <>
            {buttonItems.map((btn, index) => {
                const pct = ((index + 1) / (buttonItems.length + 1)) * 100;
                return (
                    <span key={`lbl-${btn.id}`}
                        style={{ position: 'absolute', bottom: 6, left: `${pct}%`, transform: 'translateX(-50%)', maxWidth: 48 }}
                        className="text-[8px] font-bold text-violet-300 pointer-events-none select-none truncate text-center">
                        {btn.text ? String(btn.text).slice(0, 8) : index + 1}
                    </span>
                );
            })}
            {buttonItems.map((btn, index) => {
                const pct = ((index + 1) / (buttonItems.length + 1)) * 100;
                return (
                    <Handle key={btn.id} type="source" id={`source-${btn.id}`}
                        position={Position.Bottom} style={{ left: `${pct}%` }}
                        className="!w-3 !h-3 !bg-violet-500 !border-2 !border-violet-600" />
                );
            })}
        </>
    );

    if (nodeType === 'order_bump' && !isStart) {
        const hideDecline = Boolean(data?.orderBumpHideDecline);
        return (
            <>
                <span style={{ position: 'absolute', bottom: 6, left: '25%', transform: 'translateX(-50%)' }}
                    className="text-[8px] font-bold text-[#22c55e] pointer-events-none select-none">
                    ACEITOU
                </span>
                <Handle type="source" id="source-accepted" position={Position.Bottom} style={{ left: '25%' }}
                    className="!w-3 !h-3 !bg-[#22c55e] !border-2 !border-[#16a34a]" />
                {!hideDecline && (
                    <>
                        <span style={{ position: 'absolute', bottom: 6, left: '75%', transform: 'translateX(-50%)' }}
                            className="text-[8px] font-bold text-red-400 pointer-events-none select-none">
                            RECUSOU
                        </span>
                        <Handle type="source" id="source-declined" position={Position.Bottom} style={{ left: '75%' }}
                            className="!w-3 !h-3 !bg-red-400 !border-2 !border-red-600" />
                    </>
                )}
            </>
        );
    }

    if (nodeType === 'goto' && !isStart) return null;

    return <Handle type="source" position={Position.Bottom} className="w-2 h-2 bg-sky-400" />;
}
